import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet'; 
import { useEffect } from 'react';
import "./style.css";
import {Link} from "react-router-dom"
import logo  from "../../../assests/Daalchini-logo.svg"
import JunkFood from "../../../assests/JunkFood.png";
import phone from "../../../assests/phone.svg";
import lock from "../../../assests/lock.svg";
import LoadingSpinner from '../../Loading/component';
import avtar from "../../../assests/emotion1.png";

import Modal from 'react-bootstrap/Modal';
import { Loginpopup } from '../LoginPopup/Loginpopup';

const Changepasswordsuccess = ({ onChangeOfPassword, onChangeOfPasswordConfirm, onSubmit, loading }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('data') ? JSON.parse(localStorage.getItem('data')) : false;
    if (isAuthenticated && isAuthenticated.accessToken) {
      return (navigate('/'));
    }
  }, [])

  const [show, setShow] = useState(true);

  const handleClose = () => {
    setShow(false);
    navigate('/');
  };
  
  const handleShow = () => setShow(true);

  return (
    <>
      {
        loading ? <><LoadingSpinner /></> : 
        <div className="cp-mainDiv">
          <div className="cp-blurd"> </div>
          <div className="cp-logo">
            <img src={logo} alt="Daalchini Logo" />
          </div>
          <div className="cp-imgSec">
            <img src={JunkFood} alt="Junk Food" />
          </div>
          <div className="cp-formWrapper">
            <div className="row g-3">
              <div>
                <h4 className='cp-heading'>Change Password</h4>
              </div>
              <div className="row">
                <div className="col-10 py-1 w-700">
                  <input
                    style={{
                      borderRadius: "18px",
                      padding: "12px 46px 14px",
                      fontSize: "20px",
                      background: "#FFFFFF"
                    }}
                    type="text"
                    required="true"
                    className="form-control"
                    placeholder="Enter New Password"
                    aria-label="m Number"
                    min='10'
                    max='10'
                    onChange={onChangeOfPassword}
                  />
                  <span>
                    <img
                      style={{
                        marginLeft: "24px",
                        marginTop: "-82px",
                        width: "14px"
                      }}
                      src={phone}
                      alt="Phone Icon"
                    />
                  </span>
                </div>

                <div className="d-grid col-10 py-3">
                  <input
                    style={{
                      borderRadius: "18px",
                      padding: "12px 52px 14px",
                      fontSize: "20px",
                      background: "#FFFFFF"
                    }}
                    type="password"
                    id="myInput"
                    className="form-control col-6"
                    required="true"
                    placeholder="Confirm Password"
                    onChange={onChangeOfPasswordConfirm}
                  />
                  <span>
                    <img
                      style={{
                        marginTop: "-84px",
                        marginLeft: "20px"
                      }}
                      src={lock}
                      alt="Lock Icon"
                    />
                  </span>
                </div>

                {/* ==============================================
                    CUSTOM SUCCESS MODAL WITH UNIQUE CLASS
                    FIXED: Clickable modal
                    ============================================== */}
                <Modal
                  show={show}
                  onHide={handleClose}
                  centered
                  backdrop="static"
                  keyboard={false}
                  dialogClassName="cp-success-modal"
                  contentClassName="cp-success-content"
                  className="cp-modal-wrapper"
                  style={{ zIndex: 9999 }}
                >
                  <div className="cp-success-card">
                    <div className="cp-success-header">
                      <img className="cp-avatar-img" src={avtar} alt="Success" />
                    </div>
                    <div className="cp-success-body">
                      <p className="cp-success-title">Congratulations</p>
                      <span className="cp-success-message">Password changed successfully.</span>
                    </div>
                    <div className="cp-success-footer">
                      <Link to="/" className="cp-success-link" onClick={handleClose}>
                        <p className="cp-login-btn">Login</p>
                      </Link>
                    </div>
                  </div>
                </Modal>

                <div className="d-grid gap-4 col-10 py-5">
                  <button
                    style={{
                      borderRadius: "18px",
                      padding: "12px 32px 14px",
                      fontSize: "20px",
                      textTransform: 'uppercase'
                    }}
                    className="btn btn-success"
                    type="submit"
                    onClick={onSubmit}
                  >
                    Save
                  </button>
                </div>
                <div>
                  <div className="col-10 d-grid justify-content-center">
                    <p>
                      Already Have an Account ?
                      <Link to="/" style={{ color: "#3282FF", textDecoration: "none" }}> Sign in</Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default Changepasswordsuccess;